import { I as l } from "./init-promise-deferred.util-29i-jPRG.mjs";
const d = (a) => {
  console.warn(
    `Couldn't load ${a || "shell"} metadata, no dependencies are going to be shared nor modules are going to be exposed.`
  );
};
async function h(a = "", r = "") {
  return fetch(`${a}/remoteEntry.json`, { cache: "no-store" }).then((t) => t.ok ? t.json() : (d(r), Promise.resolve({ shared: [], exposes: [] }))).then((t) => {
    const c = r.split("/")[0];
    return [
      // Create shared dependencies map -> { dep: dep-path }
      t.shared.reduce((s, e) => {
        var o;
        const i = (o = e.exports) == null ? void 0 : o.reduce(
          (n, p) => ({
            [`${e.packageName}/${p}`]: `${e.path}/${p}`,
            ...n
          }),
          {}
        );
        return {
          [e.packageName]: e.path,
          ...i,
          ...s
        };
      }, {}),
      // Create exposed modules map -> { remote-origin/module: module-path  }
      t.exposes.reduce(
        (s, e) => ({
          [e.key.replace("./", `${c}/`)]: e.path.replace("./", `${a}/`),
          ...s
        }),
        {}
      )
    ];
  }).catch(() => (d(r), Promise.resolve([{}, {}])));
}
async function g(a) {
  var r, t, c, s;
  try {
    let e = {}, i = {};
    a && await Promise.allSettled(
      Object.entries(a).map(
        ([o, n]) => h(n, o).then(([p, m]) => {
          i = { ...i, ...m }, e = { ...e, [n + "/"]: p };
        })
      )
    ), await h().then(([o]) => {
      const n = document.createElement("script");
      n.type = "importmap-shim", n.textContent = JSON.stringify({
        imports: { ...o, ...i },
        scopes: e
      }), document.body.appendChild(n);
    }).catch((o) => {
      throw d(), o;
    }), (t = (r = l).resolve) == null || t.call(r);
  } catch {
    (s = (c = l).reject) == null || s.call(c);
  }
}
export {
  g as initMfes
};
